export const endPoints = {
    SCHEDULER: {
        GET: '/v3/scheduler/info/get',
        SAVE: '/v3/scheduler/schedulerbooking',
        COMPANY_LOGO: '/v3/scheduler/getcompanylogo',
        CANCEL_APPOINTMENT:'/v3/appointments/schedulerappointmentcancel',
        MAIL_SEND:'/v3/appointments/mailsendaftercancelappo',
        GET_STATES: '/v3/form/get/state/listvalues',
    },
    COMPANY_SCHEDULER: {
        GET: '/v3/scheduler/company/info/get',
        GET_AVAILABILITY: '/v3/scheduler/company/availability/get',
        GET_TECHNICIANS: '/v3/scheduler/company/technicians/get',
    }
}